// extracted by mini-css-extract-plugin
module.exports = {"viewSwitcher":"ViewSwitcher_viewSwitcher__xuY71","selectedView":"ViewSwitcher_selectedView__1b2df"};